module.exports = __webpack_public_path__ + "img/Klipsu-Mestari.8542f290.png";